module.exports = __webpack_public_path__ + "static/media/other.81de2456.svg";